import { Component } from '@angular/core';
import { NgForage } from 'ngforage';
import { SignPhoneNumberAdjustment } from 'src/app/model/sign/phone/sign-phone-number-adjustment';
import { EditAssociationComponent } from '../edit-association.component';
import { SignPhoneNumberAdjustmentControllerRequestService } from '../../../../../services/api/sign-associations/implementations/sign-phone-number-adjustment-controller-request.service';
import { SignPhoneNumberAdjustmentFactory } from 'src/app/services/stock/phone/factory/sign-phone-number-adjustment-factory';

@Component({
  selector: 'sign-phone-number-adjustment-edit',
  templateUrl: '../edit-association.component.html',
  styleUrls: ['../edit-association.component.scss']
})
export class SignPhoneNumberAdjustmentEditComponent extends EditAssociationComponent<
  SignPhoneNumberAdjustment
> {
  constructor(
    protected ngForage: NgForage,
    private signPhoneNumberAdjustmentFactory: SignPhoneNumberAdjustmentFactory,
    private signPhoneNumberAdjustmentControllerRequestService: SignPhoneNumberAdjustmentControllerRequestService
  ) {
    super(ngForage);
  }

  protected initializeAssociationType(): void {
    this.associationType = 'SignPhoneNumberAdjustment';
  }

  protected initializeAssocObject(): void {
    if (this.assocObject == null) {
      this.assocObject = this.signPhoneNumberAdjustmentFactory.createSignPhoneNumberAdjustment();
      this.loading = false;
    } else {
      this.signPhoneNumberAdjustmentControllerRequestService
        .getById(this.assocObject.id)
        .then((signPhoneNumberAdjustment: SignPhoneNumberAdjustment) => {
          this.assocObject = signPhoneNumberAdjustment;
          this.loading = false;
        });
    }
  }

  protected getSavePromise(): Promise<SignPhoneNumberAdjustment> {
    return this.assocObject.id == null
      ? this.signPhoneNumberAdjustmentControllerRequestService.create(
          this.assocObject,
          this.signId
        )
      : this.signPhoneNumberAdjustmentControllerRequestService.update(
          this.assocObject,
          this.signId
        );
  }
}
